'use client';

import * as React from 'react';
export const CalendarGridRootContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CalendarGridRootContext.displayName = "CalendarGridRootContext";
export function useCalendarGridRootContext() {
  const context = React.useContext(CalendarGridRootContext);
  if (context === undefined) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: `CalendarGridRootContext` is missing. CalendarGrid parts must be placed within <CalendarGrid.Root />.');
  }
  return context;
}